<template>
    <div class="order-details-debug">
      <h2>Order Details Debug</h2>
      <ul v-if="orders && orders.length">
        <li v-for="(order, index) in orders" :key="index">
          <strong>Order {{ index + 1 }}:</strong>
          <div>Order Number: {{ order.ord_no }}</div>
          <div>Part Number: {{ order.item_no }}</div>
          <div>Order Quantity: {{ order.ord_qty }}</div>
          <div>Machine: {{ order.machine }}</div>
          <div>Start Date: {{ order.start_date }}</div>
          <div>End Date: {{ order.end_date }}</div>
          <!-- Add any other details you want to display here -->
        </li>
      </ul>
      <p v-else>No orders available.</p>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        orders: []
      };
    },
    mounted() {
      // Fetch the order details
      this.fetchOrderDetails();
    },
    methods: {
      fetchOrderDetails() {
        axios.get('/getCurrentSchedule')
          .then(response => {
            this.orders = response.data;
            console.log('Orders fetched:', this.orders);
          })
          .catch(error => {
            console.error('Error fetching orders:', error);
          });
      }
    }
  };
  </script>
  
  <style>
  .order-details-debug {
    padding: 20px;
    border: 1px solid #ccc;
    background-color: #f9f9f9;
    margin: 20px 0;
  }
  
  .order-details-debug ul {
    list-style-type: none;
    padding: 0;
  }
  
  .order-details-debug li {
    margin-bottom: 15px;
  }
  </style>
  